module.exports = __webpack_public_path__ + "img/icon-slide5.3ea20f79.jpg";